var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentoTramiteCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.309,
    height: 30.04,
    viewBox: "0 0 19.309 30.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #316094;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictograma_-_Documentos_en_Tr\\xE1mite_Estado_con_cursor_encima_",
    "data-name": "Pictograma - Documentos en Tr\\xE1mite (Estado con cursor encima)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4534",
    "data-name": "Trazado 4534",
    className: "cls-1",
    d: "M0,0V8.36l.3.221L2.139,9.91l1.131.82,1.02.741,1.93,1.4.21.15,1.45,1.051-1.321.949-.129.09L4.29,16.66l-.69.5L2.139,18.221.63,19.31,0,19.77V30.04H19.309V19.78l-.649-.47-1.5-1.089L15.69,17.16l-.671-.479L12.87,15.12l-.14-.1-1.321-.949L12.87,13.01l.2-.14,1.949-1.409,1-.731,1.14-.82L18.99,8.581l.319-.231V0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1988",
    "data-name": "Rect\\xE1ngulo 1988",
    className: "cls-2",
    width: 10.73,
    height: 2.146,
    transform: "translate(4.288 23.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4535",
    "data-name": "Trazado 4535",
    className: "cls-2",
    d: "M9.658,10.208l5.361-3.85L13.8,4.668,9.653,7.651,5.5,4.668,4.289,6.358l5.361,3.85v.006l0,0,0,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentoTramiteCursor);
export default __webpack_public_path__ + "static/media/documentoTramiteCursor.7525c244ccd4849b5132437879d6d58e.svg";
export { ForwardRef as ReactComponent };